import { useEffect } from 'react';

export const SITE_URL = 'https://northwesthaul.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/trailers/ai/maxxd-c4x-7k.jpg`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export function useSeo({ title, description, path = '/', image = DEFAULT_OG_IMAGE, noindex = false }) {
  useEffect(() => {
    if (!title) return;
    const url = `${SITE_URL}${path}`;
    const img = image.startsWith('http') ? image : `${SITE_URL}${image}`;
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setCanonical(url);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Northwest Haul Rentals');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);
  }, [title, description, path, image, noindex]);
}
